"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeeDebug = void 0;
const balance = __importStar(require("./modules/debug/balance"));
const chequebook = __importStar(require("./modules/debug/chequebook"));
const connectivity = __importStar(require("./modules/debug/connectivity"));
const settlements = __importStar(require("./modules/debug/settlements"));
const stake = __importStar(require("./modules/debug/stake"));
const states = __importStar(require("./modules/debug/states"));
const status = __importStar(require("./modules/debug/status"));
const transactions = __importStar(require("./modules/debug/transactions"));
const cafe_utility_1 = require("cafe-utility");
const stamps = __importStar(require("./modules/debug/stamps"));
const tag = __importStar(require("./modules/debug/tag"));
const types_1 = require("./types");
const error_1 = require("./utils/error");
const type_1 = require("./utils/type");
const url_1 = require("./utils/url");
class BeeDebug {
    constructor(url, options) {
        (0, url_1.assertBeeUrl)(url);
        // Remove last slash if present, as our endpoint strings starts with `/...`
        // which could lead to double slash in URL to which Bee responds with
        // unnecessary redirects.
        this.url = (0, url_1.stripLastSlash)(url);
        this.requestOptions = {
            baseURL: this.url,
            timeout: options?.timeout ?? false,
            headers: options?.headers,
            onRequest: options?.onRequest,
            adapter: options?.adapter,
        };
    }
    async getNodeAddresses(options) {
        (0, type_1.assertRequestOptions)(options);
        return connectivity.getNodeAddresses(this.getRequestOptionsForCall(options));
    }
    async getBlocklist(options) {
        (0, type_1.assertRequestOptions)(options);
        return connectivity.getBlocklist(this.getRequestOptionsForCall(options));
    }
    /**
     * Retrieve tag extended information from Bee node
     *
     * @param tagUid UID or tag object to be retrieved
     * @throws TypeError if tagUid is in not correct format
     *
     * @see [Bee docs - Syncing / Tags](https://docs.ethswarm.org/docs/access-the-swarm/syncing)
     * @see [Bee API reference - `GET /tags/{uid}`](https://docs.ethswarm.org/debug-api/#tag/Tag)
     *
     */
    async retrieveExtendedTag(tagUid, options) {
        (0, type_1.assertRequestOptions)(options);
        if ((0, type_1.isTag)(tagUid)) {
            tagUid = tagUid.uid;
        }
        else if (typeof tagUid === 'number') {
            (0, type_1.assertNonNegativeInteger)(tagUid, 'UID');
        }
        else {
            throw new TypeError('tagUid has to be either Tag or a number (UID)!');
        }
        return tag.retrieveExtendedTag(this.getRequestOptionsForCall(options), tagUid);
    }
    /**
     * Get list of peers for this node
     */
    async getPeers(options) {
        (0, type_1.assertRequestOptions)(options);
        return connectivity.getPeers(this.getRequestOptionsForCall(options));
    }
    async removePeer(peer, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertAddress)(peer);
        return connectivity.removePeer(this.getRequestOptionsForCall(options), peer);
    }
    async getTopology(options) {
        (0, type_1.assertRequestOptions)(options);
        return connectivity.getTopology(this.getRequestOptionsForCall(options));
    }
    async pingPeer(peer, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertAddress)(peer);
        return connectivity.pingPeer(this.getRequestOptionsForCall(options), peer);
    }
    /*
     * Balance endpoints
     */
    /**
     * Get the balances with all known peers including prepaid services
     */
    async getAllBalances(options) {
        (0, type_1.assertRequestOptions)(options);
        return balance.getAllBalances(this.getRequestOptionsForCall(options));
    }
    /**
     * Get the balances with a specific peer including prepaid services
     *
     * @param address Swarm address of peer
     */
    async getPeerBalance(address, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertAddress)(address);
        return balance.getPeerBalance(this.getRequestOptionsForCall(options), address);
    }
    /**
     * Get the past due consumption balances with all known peers
     */
    async getPastDueConsumptionBalances(options) {
        (0, type_1.assertRequestOptions)(options);
        return balance.getPastDueConsumptionBalances(this.getRequestOptionsForCall(options));
    }
    /**
     * Get the past due consumption balance with a specific peer
     *
     * @param address Swarm address of peer
     */
    async getPastDueConsumptionPeerBalance(address, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertAddress)(address);
        return balance.getPastDueConsumptionPeerBalance(this.getRequestOptionsForCall(options), address);
    }
    /*
     * Chequebook endpoints
     */
    /**
     * Get the address of the chequebook contract used.
     *
     * **Warning:** The address is returned with 0x prefix unlike all other calls.
     * https://github.com/ethersphere/bee/issues/1443
     */
    async getChequebookAddress(options) {
        (0, type_1.assertRequestOptions)(options);
        return chequebook.getChequebookAddress(this.getRequestOptionsForCall(options));
    }
    /**
     * Get the balance of the chequebook
     */
    async getChequebookBalance(options) {
        (0, type_1.assertRequestOptions)(options);
        return chequebook.getChequebookBalance(this.getRequestOptionsForCall(options));
    }
    /**
     * Get last cheques for all peers
     */
    async getLastCheques(options) {
        (0, type_1.assertRequestOptions)(options);
        return chequebook.getLastCheques(this.getRequestOptionsForCall(options));
    }
    /**
     * Get last cheques for the peer
     *
     * @param address  Swarm address of peer
     */
    async getLastChequesForPeer(address, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertAddress)(address);
        return chequebook.getLastChequesForPeer(this.getRequestOptionsForCall(options), address);
    }
    /**
     * Get last cashout action for the peer
     *
     * @param address  Swarm address of peer
     */
    async getLastCashoutAction(address, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertAddress)(address);
        return chequebook.getLastCashoutAction(this.getRequestOptionsForCall(options), address);
    }
    /**
     * Cashout the last cheque for the peer
     *
     * @param address  Swarm address of peer
     * @param options
     * @param options.gasPrice Gas price for the cashout transaction in WEI
     * @param options.gasLimit Gas limit for the cashout transaction in WEI
     */
    async cashoutLastCheque(address, options, requestOptions) {
        (0, type_1.assertCashoutOptions)(options);
        (0, type_1.assertAddress)(address);
        return chequebook.cashoutLastCheque(this.getRequestOptionsForCall(requestOptions), address, options);
    }
    /**
     * Deposit tokens from overlay address into chequebook
     *
     * @param amount  Amount of tokens to deposit (must be positive integer)
     * @param gasPrice Gas Price in WEI for the transaction call
     * @return string  Hash of the transaction
     */
    async depositTokens(amount, gasPrice, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertNonNegativeInteger)(amount);
        if (gasPrice) {
            (0, type_1.assertNonNegativeInteger)(gasPrice);
        }
        return chequebook.depositTokens(this.getRequestOptionsForCall(options), amount, gasPrice);
    }
    /**
     * Withdraw tokens from the chequebook to the overlay address
     *
     * @param amount  Amount of tokens to withdraw (must be positive integer)
     * @param gasPrice Gas Price in WEI for the transaction call
     * @return string  Hash of the transaction
     */
    async withdrawTokens(amount, gasPrice, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertNonNegativeInteger)(amount);
        if (gasPrice) {
            (0, type_1.assertNonNegativeInteger)(gasPrice);
        }
        return chequebook.withdrawTokens(this.getRequestOptionsForCall(options), amount, gasPrice);
    }
    /*
     * Settlements endpoint
     */
    /**
     * Get amount of sent and received from settlements with a peer
     *
     * @param address  Swarm address of peer
     */
    async getSettlements(address, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertAddress)(address);
        return settlements.getSettlements(this.getRequestOptionsForCall(options), address);
    }
    /**
     * Get settlements with all known peers and total amount sent or received
     */
    async getAllSettlements(options) {
        (0, type_1.assertRequestOptions)(options);
        return settlements.getAllSettlements(this.getRequestOptionsForCall(options));
    }
    /**
     * Get health of node
     */
    async getHealth(options) {
        (0, type_1.assertRequestOptions)(options);
        return status.getHealth(this.getRequestOptionsForCall(options));
    }
    /**
     * Get readiness of node
     */
    async getReadiness(options) {
        (0, type_1.assertRequestOptions)(options);
        return status.getReadiness(this.getRequestOptionsForCall(options));
    }
    /**
     * Get mode information of node
     */
    async getNodeInfo(options) {
        (0, type_1.assertRequestOptions)(options);
        return status.getNodeInfo(this.getRequestOptionsForCall(options));
    }
    /**
     * Connnects to a node and checks if it is a supported Bee version by the bee-js
     *
     * @returns true if the Bee node version is supported
     * @deprecated Use `BeeDebug.isSupportedExactVersion()` instead
     */
    async isSupportedVersion(options) {
        (0, type_1.assertRequestOptions)(options);
        return status.isSupportedVersion(this.getRequestOptionsForCall(options));
    }
    /**
     * Connects to a node and checks if its version matches with the one that bee-js supports.
     *
     * Be aware that this is the most strict version check and most probably
     * you will want to use more relaxed API-versions based checks like
     * `BeeDebug.isSupportedApiVersion()`, `BeeDebug.isSupportedMainApiVersion()` or `BeeDebug.isSupportedDebugApiVersion()`
     * based on your use-case.
     *
     * @param options
     */
    async isSupportedExactVersion(options) {
        (0, type_1.assertRequestOptions)(options);
        return status.isSupportedExactVersion(this.getRequestOptionsForCall(options));
    }
    /**
     * Connects to a node and checks if its main's API version matches with the one that bee-js supports.
     *
     * This is useful if you are not using `BeeDebug` class (for anything else then this check)
     * and want to make sure about compatibility.
     *
     * @param options
     */
    async isSupportedMainApiVersion(options) {
        (0, type_1.assertRequestOptions)(options);
        return status.isSupportedMainApiVersion(this.getRequestOptionsForCall(options));
    }
    /**
     * Connects to a node and checks if its Debug API version matches with the one that bee-js supports.
     *
     * This is useful if you are not using `Bee` class in your application and want to make sure
     * about compatibility.
     *
     * @param options
     */
    async isSupportedDebugApiVersion(options) {
        (0, type_1.assertRequestOptions)(options);
        return status.isSupportedDebugApiVersion(this.getRequestOptionsForCall(options));
    }
    /**
     *
     * Connects to a node and checks if its Main and Debug API versions matches with the one that bee-js supports.
     *
     * This should be the main way how to check compatibility for your app and Bee node.
     *
     * @param options
     */
    async isSupportedApiVersion(options) {
        (0, type_1.assertRequestOptions)(options);
        return status.isSupportedDebugApiVersion(this.getRequestOptionsForCall(options));
    }
    /**
     * Returns object with all versions specified by the connected Bee node (properties prefixed with `bee*`)
     * and versions that bee-js supports (properties prefixed with `supported*`).
     *
     * @param options
     */
    async getVersions(options) {
        (0, type_1.assertRequestOptions)(options);
        return status.getVersions(this.getRequestOptionsForCall(options));
    }
    /**
     * Get reserve state
     */
    async getReserveState(options) {
        (0, type_1.assertRequestOptions)(options);
        return states.getReserveState(this.getRequestOptionsForCall(options));
    }
    /**
     * Get chain state
     */
    async getChainState(options) {
        (0, type_1.assertRequestOptions)(options);
        return states.getChainState(this.getRequestOptionsForCall(options));
    }
    /**
     * Get wallet balances for xDai and BZZ of the Bee node
     *
     * @param options
     */
    async getWalletBalance(options) {
        (0, type_1.assertRequestOptions)(options);
        return states.getWalletBalance(this.getRequestOptionsForCall(options));
    }
    /**
     * Creates new postage batch from the funds that the node has available in its Ethereum account.
     *
     * For better understanding what each parameter means and what are the optimal values please see
     * [Bee docs - Keep your data alive / Postage stamps](https://docs.ethswarm.org/docs/access-the-swarm/keep-your-data-alive).
     *
     * **WARNING: THIS CREATES TRANSACTIONS THAT SPENDS MONEY**
     *
     * @param amount Amount that represents the value per chunk, has to be greater or equal zero.
     * @param depth Logarithm of the number of chunks that can be stamped with the batch.
     * @param options Options for creation of postage batch
     * @throws BeeArgumentError when negative amount or depth is specified
     * @throws TypeError if non-integer value is passed to amount or depth
     *
     * @see [Bee docs - Keep your data alive / Postage stamps](https://docs.ethswarm.org/docs/access-the-swarm/keep-your-data-alive)
     * @see [Bee Debug API reference - `POST /stamps`](https://docs.ethswarm.org/debug-api/#tag/Postage-Stamps/paths/~1stamps~1{amount}~1{depth}/post)
     */
    async createPostageBatch(amount, depth, options, requestOptions) {
        (0, type_1.assertPostageBatchOptions)(options);
        (0, type_1.assertPositiveInteger)(amount);
        (0, type_1.assertNonNegativeInteger)(depth);
        if (depth < types_1.STAMPS_DEPTH_MIN) {
            throw new error_1.BeeArgumentError(`Depth has to be at least ${types_1.STAMPS_DEPTH_MIN}`, depth);
        }
        if (depth > types_1.STAMPS_DEPTH_MAX) {
            throw new error_1.BeeArgumentError(`Depth has to be at most ${types_1.STAMPS_DEPTH_MAX}`, depth);
        }
        const stamp = await stamps.createPostageBatch(this.getRequestOptionsForCall(requestOptions), amount, depth, options);
        if (options?.waitForUsable !== false) {
            await this.waitForUsablePostageStamp(stamp, options?.waitForUsableTimeout);
        }
        return stamp;
    }
    /**
     * Topup a fresh amount of BZZ to given Postage Batch.
     *
     * For better understanding what each parameter means and what are the optimal values please see
     * [Bee docs - Keep your data alive / Postage stamps](https://docs.ethswarm.org/docs/access-the-swarm/keep-your-data-alive).
     *
     * **WARNING: THIS CREATES TRANSACTIONS THAT SPENDS MONEY**
     *
     * @param postageBatchId Batch ID
     * @param amount Amount to be added to the batch
     * @param options Request options
     *
     * @see [Bee docs - Keep your data alive / Postage stamps](https://docs.ethswarm.org/docs/access-the-swarm/keep-your-data-alive)
     * @see [Bee Debug API reference - `PATCH /stamps/topup/${id}/${amount}`](https://docs.ethswarm.org/debug-api/#tag/Postage-Stamps/paths/~1stamps~1topup~1{id}~1{amount}/patch)
     */
    async topUpBatch(postageBatchId, amount, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertNonNegativeInteger)(amount, 'Amount');
        (0, type_1.assertBatchId)(postageBatchId);
        await stamps.topUpBatch(this.getRequestOptionsForCall(options), postageBatchId, amount);
    }
    /**
     * Dilute given Postage Batch with new depth (that has to be bigger then the original depth), which allows
     * the Postage Batch to be used for more chunks.
     *
     * For better understanding what each parameter means and what are the optimal values please see
     * [Bee docs - Keep your data alive / Postage stamps](https://docs.ethswarm.org/docs/access-the-swarm/keep-your-data-alive).
     *
     * **WARNING: THIS CREATES TRANSACTIONS THAT SPENDS MONEY**
     *
     * @param postageBatchId Batch ID
     * @param depth Amount to be added to the batch
     * @param options Request options
     *
     * @see [Bee docs - Keep your data alive / Postage stamps](https://docs.ethswarm.org/docs/access-the-swarm/keep-your-data-alive)
     * @see [Bee Debug API reference - `PATCH /stamps/topup/${id}/${amount}`](https://docs.ethswarm.org/debug-api/#tag/Postage-Stamps/paths/~1stamps~1topup~1{id}~1{amount}/patch)
     */
    async diluteBatch(postageBatchId, depth, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertNonNegativeInteger)(depth, 'Depth');
        (0, type_1.assertBatchId)(postageBatchId);
        await stamps.diluteBatch(this.getRequestOptionsForCall(options), postageBatchId, depth);
    }
    /**
     * Return details for specific postage batch.
     *
     * @param postageBatchId Batch ID
     *
     * @see [Bee docs - Keep your data alive / Postage stamps](https://docs.ethswarm.org/docs/access-the-swarm/keep-your-data-alive)
     * @see [Bee Debug API reference - `GET /stamps/${id}`](https://docs.ethswarm.org/debug-api/#tag/Postage-Stamps/paths/~1stamps~1{id}/get)
     */
    async getPostageBatch(postageBatchId, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertBatchId)(postageBatchId);
        return stamps.getPostageBatch(this.getRequestOptionsForCall(options), postageBatchId);
    }
    /**
     * Return detailed information related to buckets for specific postage batch.
     *
     * @param postageBatchId Batch ID
     *
     * @see [Bee docs - Keep your data alive / Postage stamps](https://docs.ethswarm.org/docs/access-the-swarm/keep-your-data-alive)
     * @see [Bee Debug API reference - `GET /stamps/${id}/buckets`](https://docs.ethswarm.org/debug-api/#tag/Postage-Stamps/paths/~1stamps~1{id}~1buckets/get)
     */
    async getPostageBatchBuckets(postageBatchId, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertBatchId)(postageBatchId);
        return stamps.getPostageBatchBuckets(this.getRequestOptionsForCall(options), postageBatchId);
    }
    /**
     * Return all postage batches that has the node available.
     *
     * @see [Bee docs - Keep your data alive / Postage stamps](https://docs.ethswarm.org/docs/access-the-swarm/keep-your-data-alive)
     * @see [Bee Debug API reference - `GET /stamps`](https://docs.ethswarm.org/debug-api/#tag/Postage-Stamps/paths/~1stamps/get)
     */
    async getAllPostageBatch(options) {
        (0, type_1.assertRequestOptions)(options);
        return stamps.getAllPostageBatches(this.getRequestOptionsForCall(options));
    }
    /**
     * Return lists of all current pending transactions that the Bee made
     */
    async getAllPendingTransactions(options) {
        (0, type_1.assertRequestOptions)(options);
        return transactions.getAllTransactions(this.getRequestOptionsForCall(options));
    }
    /**
     * Return transaction information for specific transaction
     * @param transactionHash
     */
    async getPendingTransaction(transactionHash, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertTransactionHash)(transactionHash);
        return transactions.getTransaction(this.getRequestOptionsForCall(options), transactionHash);
    }
    /**
     * Rebroadcast already created transaction.
     * This is mainly needed when your transaction fall off mempool from other reason is not incorporated into block.
     *
     * @param transactionHash
     */
    async rebroadcastPendingTransaction(transactionHash, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertTransactionHash)(transactionHash);
        return transactions.rebroadcastTransaction(this.getRequestOptionsForCall(options), transactionHash);
    }
    /**
     * Cancel currently pending transaction
     * @param transactionHash
     * @param gasPrice
     */
    async cancelPendingTransaction(transactionHash, gasPrice, options) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertTransactionHash)(transactionHash);
        if (gasPrice) {
            (0, type_1.assertNonNegativeInteger)(gasPrice);
        }
        return transactions.cancelTransaction(this.getRequestOptionsForCall(options), transactionHash, gasPrice);
    }
    /**
     * Gets the staked amount of BZZ (in PLUR unit) as number string.
     *
     * @param options
     */
    async getStake(options) {
        (0, type_1.assertRequestOptions)(options);
        return stake.getStake(this.getRequestOptionsForCall(options));
    }
    /**
     * Deposits given amount of BZZ token (in PLUR unit).
     *
     * Be aware that staked BZZ tokens can **not** be withdrawn.
     *
     * @param amount Amount of BZZ token (in PLUR unit) to be staked. Minimum is 100_000_000_000_000_000 PLUR (10 BZZ).
     * @param options
     */
    async depositStake(amount, options, requestOptions) {
        (0, type_1.assertRequestOptions)(options);
        (0, type_1.assertTransactionOptions)(options);
        await stake.stake(this.getRequestOptionsForCall(requestOptions), amount, options);
    }
    /**
     * Get current status of node in redistribution game
     *
     * @param options
     */
    async getRedistributionState(options) {
        (0, type_1.assertRequestOptions)(options);
        return stake.getRedistributionState(this.getRequestOptionsForCall(options));
    }
    async waitForUsablePostageStamp(id, timeout = 120000) {
        const TIME_STEP = 1500;
        for (let time = 0; time < timeout; time += TIME_STEP) {
            const stamp = await this.getPostageBatch(id);
            if (stamp.usable) {
                return;
            }
            await cafe_utility_1.System.sleepMillis(TIME_STEP);
        }
        throw new error_1.BeeError('Timeout on waiting for postage stamp to become usable');
    }
    getRequestOptionsForCall(options) {
        return options ? cafe_utility_1.Objects.deepMerge2(this.requestOptions, options) : this.requestOptions;
    }
}
exports.BeeDebug = BeeDebug;
